import * as React from "react";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ItemList from "./ListItem";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import CreateIcon from "@mui/icons-material/Create";

const lists = []

export default function AlignItemsList(props) {
  return (
    <List
      sx={{ width: "100%", maxWidth: 360 }}
      onClick={() => console.log("Display post content!")}
    >
      <Tooltip title="Write" placement="top-end">
        <Button
          variant="outlined"
          startIcon={<CreateIcon />}
          
        >
          Write
        </Button>
      </Tooltip>
      {lists.map((list) => (
        <React.Fragment>
          <ItemList details={list} />
          <Divider variant="inset" component="li" />
        </React.Fragment>
      ))}
    </List>
  );
}
